import React, { useMemo } from 'react'
import { BoardContext } from 'dataProviders/Board'

type Props = {
  boardId: number
}

const ModalBoardContext: React.FC<Props> = ({
  children,
  boardId,
}) => {
  const boardContextValue = useMemo(() => ({
    id: boardId || 0
  }), [boardId])

  return (
    <BoardContext.Provider value={boardContextValue}>
      {children}
    </BoardContext.Provider>
  )
}

export default ModalBoardContext
